export const environment = {
  production: false,
  baseUrl: "https://dev-0.gymbook.in",
  rzpKey: "rzp_test_RZl5eeMSMYlKQM",
  COOKIES_BASE_URL: ".gymbook.in",
  APP_BASE_URL: "https://devpayments.gymbook.in", // current app base url,
  AUTH_APP_BASE_URL: "https://authdev.gymbook.in", // AUTH BASE URl
};
